import { Reducer } from "react";
import { Action } from "redux";
import Actions from "../actions";
import { SessionState } from "./state";
import { LoggedInAction, SessionUserUpdatedAction } from "./types";
import { ErrorAction } from "../types";

const initialState: SessionState = {
    isLoggingIn: false,
    user: undefined,
}

export const reconsilor = (state: SessionState): SessionState => ({
    ...initialState,
    ...state,
    isLoggingIn: false,
    user: state.user ? {
        ...state.user,
        features: Array.isArray(state.user.features) ? state.user.features : [],
        permissions: Array.isArray(state.user.permissions) ? state.user.permissions : [],
        businesses: Array.isArray(state.user.businesses) ? state.user.businesses : [],
        // Keep companies for backward compatibility during transition
        companies: Array.isArray(state.user.companies) ? state.user.companies : [],
    } : undefined,
});

export const reducer: Reducer<SessionState | undefined, Action<Actions>> = (state = initialState, action): SessionState => {
    switch (action.type) {
        case Actions.LoggedOut:
            return initialState;
        case Actions.LoggingIn:
            return handleLoggingIn(state);
        case Actions.LoggedIn:
            return handleLoggedIn(state, action as LoggedInAction);
        case Actions.LoginFailed:
            return handleLoginFailed(state, action as ErrorAction);
        case Actions.SessionUserUpdated:
            return handleSessionUserUpdated(state, action as SessionUserUpdatedAction);
        case Actions.SystemNotesCleared:
            return state.user ? { ...state, user: { ...state.user, systemNotes: [] } } : state;
        default:
            return state;
    }
};

const handleLoggingIn = (state: SessionState): SessionState => ({
    ...state,
    isLoggingIn: true,
});

const handleLoggedIn = (state: SessionState, action: LoggedInAction): SessionState => ({
    ...state,
    user: action.payload,
    isLoggingIn: false,
});

const handleLoginFailed = (state: SessionState, action: ErrorAction): SessionState => ({
    ...state,
    isLoggingIn: false,
});

const handleSessionUserUpdated = (state: SessionState, action: SessionUserUpdatedAction): SessionState => ({
    ...state,
    user: state.user ? {
        ...state.user,
        ...action.payload,
    } : undefined,
});